<template>
	<div id="chart">
		<apexchart
			type="bar"
			height="350"
			:colors="colors"
			:options="chartOptions"
			:series="series"
			:categories="categories"
		></apexchart>
	</div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import Helper from "@utils/misc.js"

export default {
	name: "TransactionColumnChart",
	components: {
		apexchart: VueApexCharts,
	},
	props: ["colors", "categories", "series"],
	data() {
		return {
			chartOptions: {
				series: this.series,
				colors: this.colors,
				// categories: this.categories,
				chart: {
					type: "bar",
					height: 350,
				},
				noData: {
					text: 'No data available',
					align: 'center',
					verticalAlign: 'middle',
					offsetX: 0,
					offsetY: 0,
					style: {
						color: 'red',
						fontSize: '25px',
						fontFamily: 'Montserrat'
					}
				},
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: "55%",
						endingShape: "rounded",
					},
				},
				dataLabels: {
					enabled: false,
				},
				stroke: {
					show: true,
					width: 2,
					colors: ["transparent"],
				},
				labels: this.categories,
				xaxis: {
					categories: this.categories,
				},
				yaxis: {
					title: {
						text: "Amount",
					},
				},
				fill: {
					opacity: 1,
				},
				tooltip: {
					y: {
						formatter: function(val) {
							return Helper.currencyFormat(val);
						},
					},
				},
			},
		};
	},

	watch: {
		categories : {
			// eslint-disable-next-line no-unused-vars
			async handler(newValue, oldValue) {
				this.chartOptions = {...this.chartOptions, ...{
					xaxis: {
						categories: newValue
					}
				}};
			},
		},

	}
};
</script>
